// extracted by mini-css-extract-plugin
module.exports = {"root":"FullWidthCta_root__x4sIe","title":"FullWidthCta_title__hPgfI","wrapper":"FullWidthCta_wrapper__21aE6","ctaButton":"FullWidthCta_ctaButton__rE1Ht"};